import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { AgentApprovalDto, AgentDto, DocumentDto, MsisdnDto, ResultListDto, SearchResultDocumentDto, SearchResultMsisdnDto, SubscriberFullDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpAgentApprovalService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/agent-approval', authService);
	}
	public get(id: number): Observable<AgentApprovalDto>{
		return super.doGet(true,`/${id}`);
	}
	public getNext(): Observable<AgentApprovalDto>{
		return super.doGet(true,`/next`);
	}
	public getAgent(agentId: number): Observable<AgentApprovalDto>{
		return super.doGet(true,`/agent:${agentId}`);
	}

	public doApprove(input: AgentApprovalDto): Observable<AgentApprovalDto>{
		return super.doPost(true,`/${input.id}/approve`,input);
	}
	public doReject(input: AgentApprovalDto): Observable<AgentApprovalDto>{
		return super.doPost(true,`/${input.id}/reject`,input);
	}
	public doSkip(input: AgentApprovalDto): Observable<AgentApprovalDto>{
		return super.doGet(true,`/${input.id}/skip`);
	}
}
